module.exports = __webpack_public_path__ + "img/banner_1.8e9061a1.df6519ea.jpg";